import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';

// CSS
import "./index.css";

export default function NewsletterForm() {
  const [email, setEmail] = useState("");

  return (
    <Container className="newsletterForm pt-5 pb-5">
      <div id="mc_embed_shell" style={{textAlign: "center"}}>
        <div id="mc_embed_signup">
          <Form
            action="https://gmail.us9.list-manage.com/subscribe/post?u=a2dcba318b637389538ab42e3&amp;id=154ec6663f&amp;f_id=0076c2e1f0"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            className="validate"
            target="_self"
            noValidate
          >
            <Form.Group id="mc_embed_signup_scroll">
              <h3>Subscribe to the Stocks With Nik Newsletter</h3>
              <p>
                Short, simple insights for beginner investors — straight to your inbox once a week.
                No spam. No hype. Just easy breakdowns of stocks, ETFs, trends, and the moves I’m personally watching.
              </p>

              <div
                style={{ fontSize: "14px", color: "red" }}
                className="indicates-required"
              >
                <span className="asterisk">*</span> indicates required
              </div>

              <div className="mc-field-group">
                <label htmlFor="mce-EMAIL">
                  Email Address <span className="asterisk">*</span>
                </label>
                <Form.Control
                  type="email"
                  name="EMAIL"
                  id="mce-EMAIL"
                  required
                  className="required email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  style={{margin: "auto auto"}}
                />
              </div>

              <div id="mce-responses" className="clear foot">
                <div
                  className="response"
                  id="mce-error-response"
                  style={{ display: "none" }}
                ></div>
                <div
                  className="response"
                  id="mce-success-response"
                  style={{ display: "none" }}
                ></div>
              </div>

              {/* real people should not fill this in and expect good things - 
                  do not remove this or risk form bot signups */}
              <div
                aria-hidden="true"
                style={{ position: "absolute", left: "-5000px" }}
              >
                <input
                  type="text"
                  name="b_a2dcba318b637389538ab42e3_154ec6663f"
                  tabIndex={-1}
                  defaultValue=""
                />
              </div>

              <div className="optionalParent">
                <div className="clear foot">
                  <input
                    type="submit"
                    name="subscribe"
                    id="mc-embedded-subscribe"
                    className="btn btn-primary mt-3"
                    value="Subscribe"
                  />
                </div>
              </div>
            </Form.Group>
          </Form>
        </div>
      </div>
    </Container>
  );
}
